//#region IMPORT
/** Components Import */
import { Unstable_Grid2 as Grid } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BusinessCommon } from '../../../../Components/BusinessCommon';
import { getColumnDefs1 } from './DEP_BASIC_ColumnDefs';
import { useDispatch } from 'react-redux';
import { setSearchText } from '../../../../Reducer/SearchReducer';
import { useSelector } from 'react-redux';

//#endregion
function DEP_BASIC(props) {
  //#region 변수
  const dispatch = useDispatch();
  // 부서정보 컬럼
  const columnDefs1 = getColumnDefs1(props);
  //#endregion
  const searchInfo = useSelector((state) => state.SearchInfo);

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="Department"
          saveYn="Y"
          printYn="N"
          saveClick={() => {
            if (!props.validateSelection()) return;

            props.SaveLogic1();
          }}
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            dispatch(setSearchText(e));
            props.gridRef1.current.api.setQuickFilter(e);
          }}
          conditions={[
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                {
                  type: 'combo',
                  name: '회사',
                  items: searchInfo.coList,
                  value: searchInfo.coCd,
                  onChange: async (e) => {
                    await props.handleCoChange(e);
                    await props.SearchLogic1();
                  },
                },
              ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: searchInfo.custList,
              value: searchInfo.custCd,
              onChange: async (e) => {
                await props.handleCustChange(e);
                await props.SearchLogic1();
              },
            },
          ]}
          placeholder="검색"
          grids={
            <>
              <BusinessCommon
                gridId={props.gridId1}
                getRowId={(params) => {
                  return params.data.no;
                }}
                addYn1={'Y'}
                deleteYn={'Y'}
                fileUploadYn1="Y"
                fileDownloadYn1="Y"
                addClick1={() => {
                  if (!props.validateSelection()) return;

                  props.HandleAddClick(props.gridRef1);
                }}
                deleteClick1={(e) => {
                  if (!props.validateSelection()) return;

                  const newRowExists = props.selectedRowData.some(
                    (row) => row.newYn === 'Y'
                  );

                  if (!newRowExists) {
                    props.MarkedForDeletion(props.selectedRowData);
                  } else {
                    props.NewYnErrorMsg();
                    props.inputRef.current?.focus();
                  }
                }}
                refreshClick1={() => {
                  if (!props.validateSelection()) return;
                  props.SearchLogic1();
                }}
                fileUploadClick1={() => {
                  if (!props.validateSelection()) return;
                  props.fileInputRef?.current?.click();
                }}
                fileDownloadClick1={() => {
                  if (!props.validateSelection()) return;
                  props.ExcelDownload1?.();
                }}
                title1={'부서정보'}
                title2={'부서정보(입력란)'}
                gridRef={props.gridRef1}
                columnDefs={columnDefs1}
                rowData={props.rowData}
                rowSelection="multiple"
                rowMultiSelectWithClick={true}
                setSelectedRowData={props.setSelectedRowData}
                setChangedRowData={props.setChangedRowData}
                tableData={props.tableData}
                colWidth={props.colWidth}
                suppressRowClickSelection={true}
                onCellClicked={(e) => {
                  // 필요 시 특정 행 선택 등 처리
                  const gridApi = props.gridRef1.current.api;
                  const clickedRowIndex = e.rowIndex;

                  const isCheckboxClick = e.event?.target?.type === 'checkbox';

                  if (!isCheckboxClick) {
                    gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
                    gridApi.setFocusedCell(clickedRowIndex, 'depNm1');

                    const copied = JSON.parse(JSON.stringify(e.data));
                    props.handleRowSelection(copied, clickedRowIndex);

                    gridApi
                      .getDisplayedRowAtIndex(clickedRowIndex)
                      ?.setSelected(true, false);
                  }
                }}
                onSelectionChanged={() => {
                  const gridApi = props.gridRef1?.current?.api;
                  const selectedNodes = gridApi.getSelectedNodes();
                  const selectedData = selectedNodes.map((n) => n.data);

                  props.selectedRowNosRef.current = new Set(
                    selectedData.map((r) => r.no)
                  );
                  props.setSelectedRowData(selectedData);
                }}
              />
              <input
                type="file"
                ref={props.fileInputRef}
                style={{ display: 'none' }}
                accept=".xlsx,.xls"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    props.ExcelUpload1?.(file);
                    e.target.value = '';
                  }
                }}
              />
            </>
          }
        />
      </Grid>
    </Grid>
  );
}

export default DEP_BASIC;
